import { render, staticRenderFns } from "./ChatLayout.vue?vue&type=template&id=c0f97b76&scoped=true&"
import script from "./ChatLayout.vue?vue&type=script&lang=js&"
export * from "./ChatLayout.vue?vue&type=script&lang=js&"
import style0 from "./ChatLayout.vue?vue&type=style&index=0&id=c0f97b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f97b76",
  null
  
)

export default component.exports